/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SubscriptionTypeResourceService} from "@well/resource-services";
import {SubscriptionTypeDtoModel} from "@well/domain";

@Injectable({
  providedIn: 'root'
})
export abstract class SubscriptionTypeDetailsService {

  protected constructor(protected subscriptionTypeResourceService: SubscriptionTypeResourceService) {
  }

  abstract save(resource: SubscriptionTypeDtoModel): Observable<SubscriptionTypeDtoModel>;

  getOne(uuid: string) {
    return this.subscriptionTypeResourceService.findOne(uuid);
  }
}
